import React, { useState, useEffect }  from 'react';
import { useHistory } from "react-router-dom";
import clsx from 'clsx';
import CrudTable from "../../../crud/CrudTable"
import {preformService as service, clientService, routeService, paymenttypeService, statepreformService,billService,productService} from "../../../../services"
import PrintIcon from '@mui/icons-material/Print'
import 'toasted-notes/src/styles.css';
import { useTranslation } from 'react-i18next';
import { ToastContainer, toast } from 'react-toastify';
import{pad} from '../../../utils/Data'; 
import { Box } from '@mui/system';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import PublishIcon from '@mui/icons-material/Publish';
import DownloadIcon from '@mui/icons-material/Download';

const moment = require("moment");

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'white',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

type Filter = {
    number:any,
    serie : any,
    client:any,
    from:any,
    to:any,
    state:any,
    route:any,
    paymenttype:any,
    product:any,
    lote:any
}

const initFilter:Filter =  {
    number:null,
    serie : null,
    client:null,
    from:moment().format("YYYY")+"-01-01T00:00:00Z",
    to:null,
    state:null,
    route:null,
    paymenttype:null,
    product:null,
    lote:null
};


export default function Preform() {

  const history = useHistory();
  const { t, i18n } = useTranslation();
  const [openBill, setOpenBill] = React.useState(false);
  const [idBill, setIdBill] = React.useState<any>(null);

  const queryParams = new URLSearchParams(window.location.search)
  const product = queryParams.get("product");
  const lote = queryParams.get("lote");
  initFilter['product'] = product?product:null;
  initFilter['lote'] = lote?lote:null;

  const createEstructureFilter =  [
    {
      type:"autocomplete",
      name: "route",
      service: routeService.combo,
      col: 3
    },
    {
      type:"input",
      name: "serie",
      col: 3
     },
    {
      type:"input",
      name: "number",
      inputtype:"number",
      autoFocus:true,
      col: 3
     },
     {
       type:"autocomplete",
       name: "client",
       service: clientService.combo,
       col: 3
      },
       {
        type:"input",
        name: "from",
        inputtype:"date",
        col: 3
       },
      {
        type:"input",
        name: "to",
        inputtype:"date",
        col: 3
      },
      {
        type:"autocomplete",
        name: "state",
        service: statepreformService.combo,
        col: 3
        },
        {
          type:"autocomplete",
          name: "paymenttype",
          service: paymenttypeService.combo,
          col: 3
          },
          {
            type:"autocomplete",
            name: "product",
            service: productService.combo,
            col: 3
            },
          {
            type:"input",
            name: "lote",
            col: 3
           },
  ];

  const handlePrint = (bill) => {

    var isGenerate = bill && bill.number && bill.number != '' && bill.state && bill.state.id && bill.state.id != 1;
    if (isGenerate){
      let fileName = "FacturaPreforma"+(bill.serie?bill.serie:"")+pad(+bill.number,5)+".pdf";
      service.print(bill.id,fileName,  (data,erro) =>{
        toast.success("Se ha descargado la factura preforma", {  position: toast.POSITION.TOP_CENTER });  
      });
    } else {
      toast.error("Solo se puede imprimir facturas preforma ya generados", {  position: toast.POSITION.TOP_CENTER });
    }
    
  }

  const handlePrintDirect = (bill) => {

    var isGenerate = bill && bill.number && bill.number != '' && bill.state && bill.state.id && bill.state.id != 1;
    if (isGenerate){
      let fileName = "FacturaPreforma"+(bill.serie?bill.serie:"")+pad(+bill.number,5)+".pdf";
      service.printDirect(bill.id,fileName,  (data,erro) =>{
        toast.success("Se ha impreso la factura preforma", {  position: toast.POSITION.TOP_CENTER });  
      });
    } else {
      toast.error("Solo se puede imprimir facturas preforma ya generados", {  position: toast.POSITION.TOP_CENTER });
    }
    
  }

  const handelBill = (bill) => {
    setIdBill(bill.id);
    setOpenBill(!openBill);    
  }
  
  
  const paintCell = {
    base: (value,object) => {
      if (value) {
        return <>{value.toFixed(2)}</>
      } else {
        return <></>
      }
    },
    discount: (value,object) => {
      if (value) {
        return <>{value.toFixed(2)}</>
      } else {
        return <></>
      }
    },
    iva: (value,object) => {
      if (value) {
        return <>{value.toFixed(2)}</>
      } else {
        return <></>
      }
    },
    total: (value,object) => {
      if (value) {
        return <>{value.toFixed(2)}</>
      } else {
        return <></>
      }
    },
    equivalencia: (value,object) => {
      if (value) {
        return <>{value.toFixed(2)}</>
      } else {
        return <></>
      }
    },
    tax: (value,object) => {
      if (value) {
        return <>{value.toFixed(2)}</>
      } else {
        return <></>
      }
    },
    

  }

  const generateBill = () =>{
    billService.preform(idBill, (data,error) =>{

      if (data && data.data && data.data.id){
        history.push("/bill/edit/"+data.data.id);
        window.location.reload();
      } else {
        setOpenBill(!openBill);
        toast.error(error.mes, { position: toast.POSITION.TOP_CENTER })
      }
    });
  }



  const handleCloseBill = () => {
    setOpenBill(!openBill);
  };

  useEffect(()=>{
 
  },[]);



  const conditionIsGenerate = (bill) => {
    var isGenerate = bill && bill.number && bill.number != '' && bill.state && bill.state.id && bill.state.id != 1;
    return isGenerate
  }

  const conditionDelete = (bill) => {
    var isGenerate = bill && bill.number && bill.number != '' && bill.state && bill.state.id && bill.state.id != 1;
    return !isGenerate
  }

  return (
      <><CrudTable
        service={service}
        urledit={"/preform/edit/"}
        urlnew={"/preform/new/"}
        filter={initFilter}
        i18n={"preform"}
        fieldstable={["serie","number","date","client.comercialName|client.email|client.phone","base","equivalencia","iva","total","facturada"]}
        exportfields={["number","date","client.code","client.comercialName","base","iva","equivalencia","total"]}
        defaultValues={{serie:"",number:"Borrador"}}
        moreActions={[{"handle":handlePrintDirect, icon:<PrintIcon />, condition: conditionIsGenerate},{"handle":handlePrint, icon:<DownloadIcon />, condition: conditionIsGenerate},{"handle":handelBill, icon:<PublishIcon />, condition: conditionIsGenerate}]}
        paintCell={paintCell}
        labels={{"client.comercialName|client.email|client.phone":t('bill.field.client.name')}}
        estructureForm={createEstructureFilter}
        order={true}
        expendedFilter={true}
        orderColumns={{"serie":"serie", "number":"number", "date":"date"}}  /><ToastContainer/>
      <Modal
            open={openBill}
            onClose={handleCloseBill}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description">
            <Box sx={style}>
              <div style={{marginBottom:'30px'}}>
                  ¿Quieres hacer una factura de esta factura preforma?
              </div>
              <div>
                <Button variant="outlined" color="primary" style={{marginRight:'30px'}} onClick={handleCloseBill}> No</Button>
                <Button variant="contained" color="primary" onClick={generateBill}> Sí </Button>
              </div>
          </Box>
        </Modal>
        </>

  );
}
